const InitState = {
  name: '',
  email: '',
  level: '',
  portraitUrl: '',
};

export default InitState;
